import React, { ReactNode } from 'react';
import JWTAuthProvider from '@crema/services/auth/JWTAuthProvider';

type Props = {
  children: ReactNode;
  onLogout?: () => void; // 로그아웃 시 호출될 optional callback
};

const AppAuthProvider = ({ children, onLogout }: Props) => {
  return <JWTAuthProvider onLogout={onLogout}>{children}</JWTAuthProvider>;
};

export default AppAuthProvider;
